import { render, staticRenderFns } from "./Teorico.vue?vue&type=template&id=389b10da"
import script from "./Teorico.vue?vue&type=script&lang=js"
export * from "./Teorico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports